<template>
    <div>
        <strong><i class="fas fa-check-circle"></i> Checklist/POP</strong>
        <form id="getAnexosSelecionados" @submit.prevent="getAnexosSelecionados" class="ajax_off"></form>

        <b-card v-for="checklist in checklists" :key="checklist.id">
            <template #header v-if="checklist.checklist && checklist.checklist.nome">
                <div class="d-flex align-items-center justify-content-between">
                    <h6 class="mb-0 text-uppercase">
                        {{ checklist.checklist.nome }}
                    </h6>
                    <b-dropdown right text="Outline Danger" variant="outline-secondary" no-caret>
                        <template #button-content>
                            <i class="fas fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item href="#" @click.prevent="remover(checklist)"><i class="fas fa-trash"></i> Remover
                            Checklist</b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>

            <accordion :id="`checklist-${checklist.id}-tarefas`" :data_itens="tipos" v-if="tipos.length"
                :key="checklist.id">
                <template v-slot:header="tipo" v-if="checklist.checklist && checklist.checklist.itens">
                    <div>
                        <span v-if="tipo.item">{{
                            countChecked(checklist, tipo)
                        }}</span>
                        /<span v-if="tipo.item">{{
                            checklist.checklist.itens.length
                        }}</span>
                    </div>
                </template>
                <template v-slot:content="tipo">
                    <div v-if="checklist.checklist && checklist.checklist.itens">
                        <b-card-text v-for="item in checklist.checklist.itens" :key="item.id">
                            <div class="form-check">
                                <input type="checkbox" class="check form-check-input" :checked="Boolean(
                                    parseInt(
                                        checkItem(checklist, item)
                                            .checked
                                    )
                                )
                                    " data-route="tarefas" @click.prevent="dialog(checklist, item)" /><label
                                    class="mb-0">{{ item.nome }}</label>
                                <a :href="`/download/${modelo.id}`" target="_blank" :donwload="modelo.arquivo_name"
                                    class="mr-2" v-b-tooltip.hover.top :title="modelo.arquivo_name"
                                    v-for="modelo in item.modelos" :key="modelo.id"><small>
                                        -
                                        <i class="fas fa-download"></i>
                                        Modelo</small></a>
                            </div>
                            <div>
                                <ChecklistItemStatus :status="getStatus(checklist, item)" :item_id="getItemID(checklist, item)" :name="item.nome" @updateItem="submitUpload">
                                </ChecklistItemStatus>
                            </div>
                            <div>
                                <p class="mb-1" v-if="item.observacao">
                                    <small><b>Descrição:</b>
                                        {{ item.observacao }}</small>
                                </p>
                                <a :href="item.link" target="_blank" v-if="item.link"><small>Acesse aqui para obter o
                                        documento</small></a>
                            </div>
                            <div>
                                <p v-if="checkItem(checklist, item).comment">
                                    <strong>Comentário: </strong>
                                    <span :class="checkItem(checklist, item).comment
                                        .option_id == 1
                                        ? 'text-success'
                                        : 'text-danger'
                                        ">{{
        checkItem(checklist, item).comment
            .comentario
    }}
                                    </span>
                                </p>
                                <ul>
                                    <li v-for="anexo in anexosDoItem(
                                        checklist.id,
                                        item
                                    )" :key="anexo.id">
                                        <small>{{ anexo.upload.arquivo_name }}
                                            Adicionado por:
                                            {{ anexo.upload.colaborador.name }}
                                        </small>
                                        <div>
                                            <a href="#" class="mr-2" @click.prevent="
                                                preview(anexo.upload)
                                                " v-if="anexo.upload &&
        anexo.upload.visualizar
        "><u>Visualizar</u></a>

                                            -
                                            <a class="mr-2" :href="`/api/download/${anexo.upload_id}`
                                                " :download="anexo.arquivo_name" target="_blank"><u>Download</u></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </b-card-text>
                    </div>
                </template>
            </accordion>
        </b-card>

        <input type="file" class="file-item" ref="file" multiple="" @change="submitUpload()" style="
        opacity: 0;
        height: 0px;
        width: 0px;

        position: absolute;
      " id="file-item-204" />

        <!-- <eFilePreview
      v-if="visualizar.id != ''"
      :title="visualizar.name"
      :id="`preview-${visualizar.id}`"
      :file="visualizar.link"
    /> -->
        <modal size="md" id="checklist-item-comentario" form="comentario-form" title="Comentar item" btn_save>
            <checklist-item-comentario :current_item="current_item" @updateItem="updateItem"></checklist-item-comentario>
        </modal>
        <modal id="anexos" v-if="open_anexo" form="getAnexosSelecionados" btn_save
            btn_save_name="<i class='fas fa-plus'></i> Adicionar selecionados" :title="`Anexos do Cliente: ${cartao.cliente.razao_social.length > 0
                ? cartao.cliente.razao_social
                : cartao.cliente.nome_loja
                }`
                ">
            <Anexos :cliente_documento="cartao.cliente_documento" :tarefa_id="cartao.tarefa_id" showForm checklist
                parent_name="tarefas" :parent_id="cartao.tarefa_id" ref="anexos" :BlockThisAnexos="cartao.anexos"
                @setSelecionados="updateItem" />
        </modal>
        <eFilePreview v-if="visualizar.id != ''" :title="visualizar.name" :id="`preview-${visualizar.id}`"
            :file="visualizar.link" />
    </div>
</template>

<script>
import Anexos from "../../sistema/Anexos.vue";
import Accordion from "../../sistema/Accordion.vue";
import eFilePreview from "../../sistema/eFilePreview.vue";
import ChecklistItemComentario from "./ChecklistItemComentario.vue";
import ChecklistItemStatus from "./ChecklistsItemStatus.vue";
export default {
    components: { Anexos, eFilePreview, Accordion, ChecklistItemComentario, ChecklistItemStatus },
    data() {
        return {
            open_anexo: false,
            tipos: [],

            current_tarefa_checklist_id: "",
            loading: false,
            current_item: {},
            tarefa_itens: [],
            visualizar: {
                id: "",
                name: "",
                link: ""
            }
        };
    },
    props: {
        cartao: Object,
        checklists: Array
    },
    created() {
        this.getTipos();
        this.getAllItems();
    },
    mounted() {
        const self = this;
        $(document).on("click", "#swal_comentar", function () {
            self.$swal.close();
            self.$bvModal.show("checklist-item-comentario");
        });

        $(document).on("click", "#swal_anexar", function () {
            self.$swal.close();
            self.openUpload();
        });
    },
    methods: {
        getStatus(checklist, item){
            if (checklist.itens.length > 0) {
                const get_status = checklist.itens.find(item_filter => item_filter.item_id == item.id);
                if(get_status)
                    return get_status.status
            }

            return null;        },

        getItemID(checklist, item) {
            if (checklist.itens.length > 0) {
                const get_item = checklist.itens.find(item_filter => item_filter.item_id == item.id);
                if (get_item)
                    return get_item.id;
            }
            return null;
        },

        createButton(text, id, item_id, item) {
            return `<button id='${id}' data-list_id='${item_id}' data-item='${item}' class='btn btn-primary'>
                    ${text}
                    </button>`;
        },
        dialog(checklist, item) {
            this.current_item = this.checkItem(checklist, item);
            this.current_tarefa_checklist_id = checklist.id;

            var buttons = $(
                "<div class='d-flex align-items-center justify-content-around'>"
            )
                .append(
                    this.createButton(
                        "Comentar",
                        "swal_comentar",
                        checklist.id,
                        item
                    )
                )
                .append(
                    this.createButton(
                        "Anexar",
                        "swal_anexar",
                        checklist.id,
                        item
                    )
                );

            this.$swal({
                title: `Escolha uma opção`,
                html: buttons,
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: "Fechar",
                showCloseButton: false
            });
        },
        async getTipos() {
            // let result = await this.$api.get("tipo-checklist-item");

            // this.tipos = result.data.map(item => {
            //     return {
            //         name: item.text,
            //         id: item.value
            //     };
            // });

            this.tipos = [
                {
                    name: 'Documento / Procedimento'
                }
            ]
        },
        getAnexosSelecionados() {
            this.$refs.anexos.getSelecionados();
        },
        async getAllItems() {
            const result = await this.$api.post("tarefa/checklistItens", {
                checklists: this.checklists
            });

            this.tarefa_itens = result.data.itens;
        },

        async remover(checklist) {
            const result = await this.$api.delete("tarefa/removerChecklist", {
                data: { id: checklist.id }
            });

            this.$emit("updateCartao");
        },
        openUpload() {
            this.open_anexo = true;
            setTimeout(() => {
                this.$bvModal.show("anexos");
            }, 100);
        },
        async submitUpload() {
            this.$emit("updateCartao");
        },

        async updateItem(arquivos = []) {
            await this.$api.put("tarefa/updatechecklistItens", {
                tarefa_checklist_id: this.current_tarefa_checklist_id,
                item_id: this.current_item.id,
                arquivos
            });

            this.$emit("updateCartao");
        },
        preview(anexo) {
            this.visualizar.id = "";
            this.visualizar.link = "";
            this.visualizar.name = anexo.arquivo_name;
            this.visualizar.id = anexo.id;
            this.visualizar.link = anexo.link;

            setTimeout(() => {
                this.$bvModal.show(`preview-${this.visualizar.id}`);
            }, 100);
        },
        anexosDoItem(checklist_id, item) {
            const index_item = this.tarefa_itens.findIndex(
                i =>
                    i.item_id == item.id &&
                    i.tarefa_checklist_id == checklist_id
            );
            if (index_item > -1) {
                return this.tarefa_itens[index_item].anexos;
            }

            return [];
        },
        checkItem(checklist, item) {
            let checkItem = checklist.itens.find(i => i.item_id == item.id);
            return checkItem;
        },
        countChecked(checklist, tipo) {
            return checklist.itens.filter(
                i =>
                    (i.item.tipo_id == tipo.item.id && i.checked == 1) ||
                    (!i.item.tipo_id && i.checked == 1)
            ).length;

        }
    }
};
</script>
